import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {


    useEffect(() => {
        window.scrollTo(0, 0)

    }, []);




        return (
            <div>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link> <span className="mx-2 mb-0">/</span> <strong className="text-black">Refund Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{width : "99% " ,padding : "30px 30px"}}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{fontWeight :"bold"}}>
                                {/* <h2>This Privacy Policy</h2> */}
                                <h1>Refund Policy</h1>
    <p>
        We hope that you love your purchase and are fully satisfied with our product and the shopping experience! If for any reason you are unsatisfied or find the items not suitable with a genuine reason, exchanges will be accepted within 14 days after delivery with a valid proof of purchase.
    </p>
    <p>
        Cash refunds are not obliged under any circumstances.
    </p>
    <p>
        Exchanges may be made within the 14 days provided that the garment is unworn, in its original condition with tags. Exchanges made after 14 days will be subject to management approval. We also can't accept cancellations for orders unless they are made within 48 hours of your order being placed.
    </p>

    <h2>Our exchange policy is effective if:</h2>
    <ul>
        <li>The article purchased shrinks or bleeds after the first wash.</li>
        <li>We recommend our customers to view the size chart before purchasing; however, if the size does not fit, the size of the garment can be exchanged only if it is not used or washed and all packing and tags are intact. In such cases, shipping will be paid by the customer.</li>
        <li>Any exchanges made after 14 days are subject to management discretion.</li>
    </ul>

    <h2>We don't exchange under the following scenarios:</h2>
    <ul>
        <li>When a product has been personalized or made according to customer measurements.</li>
        <li>We don't exchange products that come under Hyper SALE.</li>
    </ul>

    <div class="note">
        <strong>Note:</strong> Please ensure to follow the above conditions to facilitate a smooth exchange process.
    </div>

                                </div>
                            </div>
                        </div>
                </div>
            </div>
        )
    
}


export default Contact;